export default class CreateUserInfoModel {
  nickName: string;

  userAccount: string;

  phoneNo: string;

  phonePrefix: string;

  remark: string;

  accessGroup: string;

  constructor() {
    this.nickName = '';
    this.accessGroup = '';
    this.phoneNo = '';
    this.phonePrefix = '86';
    this.userAccount = '';
    this.remark = '';
  }
}
